import Staff from "./staff/staff_attendance";
import Teacher from "./teacher/teacher_attendance";

export default {
  modules: { Staff, Teacher },
};
